import axios from "axios";
import { toast , ToastContainer} from "react-toastify";
import { profileActions } from "../slices/profileSlice";
import { authActions } from "../slices/authSlice";


// Get user propfile 
export function getUserProfileApi(userId){
    return async(dispatch , getState ) => {
       try {

        

        const {data} = await axios.get(`https://remote-attendance.hsagroup.info/api/users/profile/${userId}` , {
            headers: {
              Authorization: "Bearer " + getState().auth.user.token,
            },
          })

        dispatch(profileActions.setProfile(data));
        
        console.log(userId);

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}


// Get All users 
export function getAllUserApi(){
    return async(dispatch , getState ) => {
       try {

        

        const {data} = await axios.get("https://remote-attendance.hsagroup.info/api/users/all-users" , {
            headers: {
              Authorization: "Bearer " + getState().auth.user.token,
            },
          })

        dispatch(profileActions.setProfiles(data));
        dispatch(profileActions.resetProfileDeleted()); // ✅ reset HERE

        

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}


// Update user propfile By Admin 
export function updateUserApi(user) {
    return async (dispatch, getState) => {
      try {
        const { data } = await axios.put(
          `https://remote-attendance.hsagroup.info/api/users/${user._id}`,
          {
            email: user.email,
            password: user.password,
            department: user.department,
            isAdmin: user.isAdmin,
            profilePicture: user.profilePicture,
          },
          {
            headers: {
              Authorization: "Bearer " + getState().auth.user.token,
            },
          }
        );
  
        toast.success(data.message);
  
        // ✅ Update the user in profiles array
        dispatch(profileActions.updateUserInProfiles(data.updatedUser));
  
      } catch (error) {
        toast.error(error.response?.data?.message || "Update failed");
        console.log(error);
      }
    };
  }
  

// Get user propfile 
export function deleteUserProfileApi(userId){
    return async(dispatch , getState ) => {
       try {

        

        const {data} = await axios.delete(`https://remote-attendance.hsagroup.info/api/users/${userId}` , {
            headers: {
              Authorization: "Bearer " + getState().auth.user.token,
            },
          })

        dispatch(profileActions.setisProfileDeleted(data));
        
        toast.warn(data?.message);

       } catch (error) {

        toast.error(error.response.data.message);
        console.log(error);
       } 
    }
}
